import axios from "axios";
import Cookies from 'universal-cookie';
import { expireTime } from "../utils";

const cookies = new Cookies();

const axiosAdmin = axios.create({
    baseURL: process.env.REACT_APP_END_POINT,
});

axiosAdmin.defaults.timeout = 600000;

axiosAdmin.interceptors.response.use(
    function (response) {
        if (response.data.code === 401) {
            cookies.remove('x-auth-token', { path: '/', expires: expireTime(), secure: true, sameSite: 'strict' });
            cookies.remove('m-auth-token', { path: '/', expires: expireTime(), secure: true, sameSite: 'strict' });
            cookies.remove('c-auth-token', { path: '/', expires: expireTime(), secure: true, sameSite: 'strict' });
            window.location.reload();
        }
        return response;
    },
    function (response) {
        if (response.data.code === 401) {
            cookies.remove('x-auth-token', { path: '/', expires: expireTime(), secure: true, sameSite: 'strict' });
            cookies.remove('m-auth-token', { path: '/', expires: expireTime(), secure: true, sameSite: 'strict' });
            cookies.remove('c-auth-token', { path: '/', expires: expireTime(), secure: true, sameSite: 'strict' });
            window.location.reload();
        }
        console.error("Looks like there was a problem. Status Code:" + response?.status);
        return Promise.reject(response);
    }
);

axiosAdmin.interceptors.request.use(function (config) {
    const token = cookies.get('x-auth-token');
    config.headers.authorization = token || '';
    config.headers.adminAuthorization = 'admin';
    return config;
});

export default axiosAdmin;